import { UPDATE_ONBOARDING_STEP } from "../actions/onboardingActions";

const CurrentContractorReducer = (state = {}, action) => {
    switch (action.type) {
    case UPDATE_ONBOARDING_STEP: {
        return { ...state, onboardingStep: action.onboardingStep };
    }
    default:
        return state;
    }
};

export default CurrentContractorReducer;
